module.exports = __webpack_public_path__ + "fonts/Didot.3d8affd7.ttf";